import * as faker from 'faker'
import moment from 'moment'
import numeral from 'numeral'

import {
  makeTransactions,
  generateMonthlyPayments
} from 'utility/makeTransactions'

const currency = val => numeral(val).format('$0,0.00')
const date = val => moment(val).format('MM/DD/YYYY')

const initialState = {
  accounts: [
    {
      id: 'ac-1',
      type: 'deposit',
      nickname: 'My Basic Checking',
      mask: '2345-S0010',
      balance: 250.0,
      metadata: [
        {
          label: 'Current Balance',
          value: currency(250.0)
        },
        {
          label: 'Available Balance',
          value: currency(150.0)
        },

        {
          label: 'Date Opened',
          value: date(faker.date.past())
        },
        {
          label: 'SubType',
          value: '0010'
        },
        {
          label: 'ACH Routing Number',
          value: '123456789'
        },
        {
          label: 'Wire Transfer Routing Number',
          value: '123456789'
        },
        {
          label: 'Type',
          value: 'Standard Checking'
        }
      ],
      transactions: makeTransactions({
        hasDeposits: true
      })
    },
    {
      id: 'ac-2',
      type: 'deposit',
      nickname: 'My Basic Savings',
      mask: '2345-S0001',
      balance: 123.0,
      metadata: [
        {
          label: 'Current Balance',
          value: currency(123.0)
        },
        {
          label: 'Available Balance',
          value: currency(123.0)
        },

        {
          label: 'Date Opened',
          value: date(faker.date.past())
        },
        {
          label: 'SubType',
          value: '0010'
        },
        {
          label: 'ACH Routing Number',
          value: '123456789'
        },
        {
          label: 'Wire Transfer Routing Number',
          value: '123456789'
        },
        {
          label: 'Type',
          value: 'Standard Savings'
        }
      ],

      transactions: makeTransactions({
        hasDeposits: true
      })
    },
    {
      id: 'ac-3',
      type: 'card',
      nickname: 'My Visa Credit',
      mask: '2222',
      balance: 2138.3,
      metadata: [
        {
          label: 'Current Balance',
          value: currency(2138.3)
        },
        {
          label: 'Interest Rate',
          value: '17.00%'
        },
        {
          label: 'Payment Amount',
          value: currency(68.0)
        },
        {
          label: 'Payment Due Date',
          value: date(faker.date.recent(-1))
        },
        {
          label: 'SubType',
          value: '0070'
        },
        {
          label: 'Total Credit',
          value: currency(20000)
        },
        {
          label: 'Available Credit',
          value: currency(20000 - 2138.3)
        },
        {
          label: 'Total Cash Advance Credit',
          value: currency(0)
        },
        {
          label: 'Available Cash Advance',
          value: currency(0)
        },
        {
          label: 'Last Statement Balance',
          value: currency(1565.22)
        },
        {
          label: 'Last Payment Date',
          value: date(faker.date.recent())
        },
        {
          label: 'Last Payment Amount',
          value: currency(156.0)
        },
        {
          label: 'Minimum Payment Due',
          value: currency(156.0)
        },
        {
          label: 'Next Statement Date',
          value: date(faker.date.recent(-1))
        },

        {
          label: 'Date Opened',
          value: date(faker.date.past())
        },
        {
          label: 'Product Name',
          value: 'Platinum Rewards'
        },
        {
          label: 'Reward Points',
          value: '1,250',
          action: 'Redeem'
        }
      ],
      transactions: makeTransactions({
        hasDeposits: false
      })
    },

    {
      id: 'ac-4',
      type: 'loan',
      nickname: 'My Car Loan',
      mask: 'C3324',
      balance: 1593.25,
      metadata: [
        {
          label: 'Current Balance',
          value: currency(1593.25)
        },
        {
          label: 'Interest Rate',
          value: '8.75%'
        },
        {
          label: 'Payment Amount',
          value: currency(265.15)
        },
        {
          label: 'Payment Due Date',
          value: date(faker.date.recent(-1)),
          action: 'Skip Payment'
        },
        {
          label: 'SubType',
          value: '0030'
        },
        {
          label: 'Outstanding Principal Balance',
          value: currency(1693.25)
        },
        {
          label: 'Last Payment Date',
          value: date(faker.date.recent())
        },
        {
          label: 'Last Payment Amount',
          value: currency(300.0)
        },

        {
          label: 'Next Statement Date',
          value: date(faker.date.recent(-1))
        },
        {
          label: 'Next Payment Amount',
          value: currency(300.0)
        },
        {
          label: 'Product Name',
          value: 'Super Auto Loans'
        },
        {
          label: 'Full Loan Number',
          value: '123456789'
        },
        {
          label: 'Automatic Payments Enabled',
          value: 'No'
        }
      ],
      transactions: generateMonthlyPayments({ num: 12, amount: 300.0 })
    },
    {
      id: 'ac-5',
      type: 'loan',
      nickname: 'My First Mortgage',
      mask: 'M9999',
      balance: 176460,
      metadata: [
        {
          label: 'Current Balance',
          value: currency(176460)
        },
        {
          label: 'Interest Rate',
          value: '4.25%'
        },
        {
          label: 'Maturity Date',
          value: '01/01/2040'
        },
        {
          label: 'Payment Amount',
          value: currency(765.15)
        },
        {
          label: 'Payment Due Date',
          value: date(faker.date.recent(-1)),
          action: 'Skip Payment'
        },
        {
          label: 'SubType',
          value: '0080'
        }
      ],
      transactions: generateMonthlyPayments({ num: 12, amount: 765.15 })
    }
  ]
}

const accounts = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT': {
      return { ...initialState }
    }
    case 'UPDATE_TRANSACTION': {
      const accountIndex = state.accounts.findIndex(
        a => a.id === action.payload.account
      )
      let accounts = [...state.accounts]
      let account = { ...accounts[accountIndex] }
      let transactions = [...account.transactions]
      const transactionIndex = transactions.findIndex(
        t => t.id === action.payload.transaction
      )
      let transaction = {
        ...transactions[transactionIndex],
        ...action.payload.data
      }
      transactions[transactionIndex] = transaction
      account.transactions = transactions
      accounts[accountIndex] = account

      return { ...state, accounts }
    }
    default: {
      return state
    }
  }
}

export default accounts
